/**
 * @generated SignedSource<<3c648f49f22650dbf3dc3e55f8ddb767>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordToggle_refetchableAutoRecordIsOnForStream$data = {
  readonly id: string;
  readonly schedulingMeetingAssistantAutomationIsActive: boolean;
  readonly " $fragmentType": "AutoRecordToggle_refetchableAutoRecordIsOnForStream";
};
export type AutoRecordToggle_refetchableAutoRecordIsOnForStream$key = {
  readonly " $data"?: AutoRecordToggle_refetchableAutoRecordIsOnForStream$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_refetchableAutoRecordIsOnForStream">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./AutoRecordToggle_AutoRecordIsOnForStream.graphql'),
      "identifierField": "id"
    }
  },
  "name": "AutoRecordToggle_refetchableAutoRecordIsOnForStream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schedulingMeetingAssistantAutomationIsActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "7b166994edf2c813147b7790d3f852f3";

export default node;
